import React from 'react';
import PropTypes, { arrayOf, shape } from 'prop-types';
import { Heading } from 'components/common';
import NoPressContent from './NoPressContent';

import './LatestUpdatesContent.scss';

const LatestUpdatesContent = ({ content, nothingToShow }) => (
  <div className="latest-update-content">
    <ul className="article-list">
      {content.length === 0 ? <NoPressContent text={nothingToShow} />
        : content
          .map((val, idx) => (
                    // eslint-disable-next-line
                    <li key={idx}>
                      <Heading as="h3">{val.title}</Heading>
                      <div className="iframe-container">
                        <iframe
                          src={val.link}
                          title={val.title}
                          className="video-iframe"
                          frameBorder="0"
                          allowFullScreen
                        />
                      </div>

                    </li>

          ))
        }
    </ul>
  </div>
);

LatestUpdatesContent.propTypes = {
  content: arrayOf(shape({
    link: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  })),
  nothingToShow: PropTypes.string,
};

LatestUpdatesContent.defaultProps = {
  content: null,
  nothingToShow: null,

};

export default LatestUpdatesContent;
